export default class VodVideoService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('vodVideos', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('vodVideos/' + id, params)
	}

    resetLocalState(id){
        return this.apiService.callPost('vodVideos/'+ id +'/resetLocalState');
    }
}



// WEBPACK FOOTER //
// ./src/service/VodVideoService.js